
// Libraries
var React = require('react');
var Modal = require('tg-modal').default;

// Assets
var close = require('images/close.svg');

// Styles
require('tg-modal/dist/default.scss');
require('./VideoModal.scss');

class VideoModal extends React.Component {

	render() {

		return (
			<div className="VideoModal">
				<Modal className="VideoModal" isOpen={this.props.isOpen} onCancel={this.props.onCancel} keyboard={true}>
					<button className="VideoModal__close" onClick={this.props.onCancel}><img src={close} alt="Close video" /></button>
					{this.props.children}
				</Modal>
			</div>
		)
	}
}

module.exports = VideoModal;



// WEBPACK FOOTER //
// ./src/components/Video/VideoModal.js